export default function About() {
  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Visual Element - No photo */}
          <div className="relative order-2 lg:order-1 flex items-center justify-center">
            <div className="relative w-full max-w-sm mx-auto">
              {/* Decorative background circles */}
              <div className="absolute -top-8 -left-8 w-48 h-48 bg-blue-50 rounded-full opacity-70"></div>
              <div className="absolute -bottom-8 -right-8 w-40 h-40 bg-blue-100 rounded-full opacity-50"></div>

              {/* Central card */}
              <div className="relative z-10 bg-white rounded-3xl shadow-xl p-10 flex flex-col items-center space-y-6 border border-gray-100">
                <div className="text-center space-y-2">
                  <p className="text-xl font-bold text-gray-900">Susana</p>
                  <p className="text-sm text-blue-600 font-medium">Asesora de Salud Previsional</p>
                  <p className="text-sm text-gray-500">Vinculada a Isapre Consalud</p>
                </div>
                <div className="w-full border-t border-gray-100 pt-6 grid grid-cols-3 gap-4 text-center">
                  <div>
                    <p className="text-2xl font-bold text-blue-600">+5</p>
                    <p className="text-xs text-gray-500 mt-1">Años de experiencia</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-blue-600">100%</p>
                    <p className="text-xs text-gray-500 mt-1">Personalizado</p>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-blue-600">24h</p>
                    <p className="text-xs text-gray-500 mt-1">Respuesta</p>
                  </div>
                </div>
              </div>

              {/* Floating badges */}
              <div className="absolute -top-4 -right-4 z-20 bg-white rounded-2xl shadow-lg px-4 py-3 flex items-center space-x-2 border border-gray-100">
                <div className="w-8 h-8 flex items-center justify-center bg-green-50 rounded-full">
                  <i className="ri-shield-check-line text-green-500 text-lg"></i>
                </div>
                <span className="text-xs font-semibold text-gray-700">Atención confiable</span>
              </div>

              <div className="absolute -bottom-4 -left-4 z-20 bg-white rounded-2xl shadow-lg px-4 py-3 flex items-center space-x-2 border border-gray-100">
                <div className="w-8 h-8 flex items-center justify-center bg-blue-50 rounded-full">
                  <i className="ri-map-pin-line text-blue-500 text-lg"></i>
                </div>
                <span className="text-xs font-semibold text-gray-700">Santiago, Chile</span>
              </div>
            </div>
          </div>

          {/* Content */}
          <div className="space-y-6 order-1 lg:order-2">
            <div className="inline-block px-4 py-2 bg-blue-50 rounded-full">
              <span className="text-sm font-medium text-blue-600">Sobre mí</span>
            </div>

            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight">
              Hola, soy Susana
            </h2>

            <div className="space-y-4 text-gray-700 leading-relaxed">
              <p className="text-lg">
                Mi objetivo es brindarte <strong className="text-gray-900">atención cercana y orientación clara</strong> para que puedas tomar las mejores decisiones sobre tu salud previsional.
              </p>

              <p className="text-lg">
                Trabajo como ejecutiva vinculada a Isapre Consalud, ofreciendo <strong className="text-gray-900">apoyo humano y profesional</strong> para ayudarte a entender planes, beneficios y opciones disponibles.
              </p>

              <p className="text-lg">
                Creo en el <strong className="text-gray-900">acompañamiento personalizado</strong>, tanto antes como después del proceso, porque sé que las decisiones de salud son importantes y merecen tiempo, claridad y confianza.
              </p>

              <p className="text-lg">
                Si necesitas orientación, estoy aquí para escucharte y ayudarte a encontrar la mejor solución para ti y tu familia.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
